<app-header ngSkipHydration></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>
